export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask加密貨幣",
            h1B: "MetaMask加密貨幣銀行",
            h1C: "DeFi Wallet加密貨幣",
            h1D: "Coinbase加密貨幣銀行",
            h1E: "MetaMask儲蓄銀行",
            h1F: "Betterment",
            h2: "邀請好友",
            h3: "綁定提款帳戶",
            h4: "參與儲蓄",
            h4B: "加密貨幣存款",
            h4C: "數位貨幣充值",
            h5: "精選理財",
            h5B: "秒合約交易",
            h5c: "存入",
            h6: "使用者池",
            h7: "USDT帳戶",
            h8: "總產量",
            h9: "有效節點",
            h10: "參與者",
            h11: "收益",
            h12: "收益記錄",
            h13: "地址",
            h14: "編號",
            h15: "常見問題",
            h16: "如何參與？",
            h17: "親愛的用戶，如果您想參與USDT錢包儲蓄，需遵守平台使用者規則，嚴格執行平台決定，接受風險部門的監督，您將自動獲得存款權限。歡迎參與，謝謝。",
            h17B: "親愛的用戶，如果您想參與USDT錢包儲蓄，需遵守平台使用者規則，嚴格執行平台決定，接受風險部門的監督，您將自動獲得存款權限。歡迎參與，謝謝。",
            h18: "如何提現？",
            h19: "每日產生的收益會自動存入帳戶餘額，USDT提現成功後會自動添加到USDT錢包帳戶。若需提現日圓，請聯繫客服中心處理。感謝您的參與與支持。",
            h19B: "每日產生的收益會自動存入帳戶餘額，USDT提現成功後會自動添加到USDT錢包帳戶。如需使用其他提現方式，請諮詢線上客服！",
            h20: "收入如何計算？",
            h21B: "以週期形式買入，VIP等級不同產生利潤不同\nVIP1  $100~$5000，利率：1.8%\nVIP2  $5000~$20000，利率：2.6%\nVIP3  $20000~$50000，利率：3.5%\nVIP4  $50000~$80000，利率：4.7%\nVIP5  $80000~$120000，利率：5.3%\nVIP6  $120000~$160000，利率：6.2%\nVIP7  $160000~$200000，利率：7.3%\nVIP8    $200000以上，利率：8%\n\n",
            h21: "成功加入後，儲蓄合約將開始計算收益。",
            h22: "儲蓄的收益來自哪裡？",
            h23: "使用者參與儲蓄後，儲蓄合約生效。每天 00:00、12:00 共 2 次結算利息。儲蓄合約生效後，資金進入託管模式，平台負責資金安全。為保障帳戶資金安全，請嚴格遵守平台規則，如有問題請聯繫線上客服。",
            h23B: "使用者參與儲蓄後，儲蓄合約生效。每天 00:00、12:00 共 2 次結算利息。儲蓄合約生效後，資金進入託管模式，平台負責資金安全。為保障帳戶資金安全，請嚴格遵守平台規則，如有問題請聯繫線上客服。",
            h24: "獎金是多少？",
            h25: "您可以分享我的平台給好友。當好友參與後，您可獲得其首次入金金額20%的推薦獎勵，並永久獲得其收益10%的推薦佣金。分享的公開連結在首頁右上角。",
            h25B: "您可以分享本平台給好友。當好友參與後，您可獲得其首次入金金額20%的推薦獎勵，並永久獲得其收益10%的推薦佣金。分享連結在首頁右上角。",
            h26: "可用餘額",
            h27: "存入金額",
        
            h88: "平台背景",
            h89: "Betterment\n成立時間：2008 年\n總部：美國紐約\n定位：智能投顧（Robo-Advisor）與金融科技（FinTech），提供自動化投資組合與現金管理\n監管機構：受金融中心交易委員會（SEC）監管，同時是 FINRA 成員\n客戶規模：管理資產超過 400 億美元\n客戶群體：超過 80 萬名個人與企業客戶",
            h90: "平台優勢",
            h91: "✔️ 美國最早的 Robo-Advisor，經驗成熟\n✔️ 投資組合基於現代資產配置理論（MPT），分散風險\n✔️ 提供 稅收優化功能\n✔️ 高利率現金帳戶，流動性強\n✔️ 全程數位化操作，介面簡潔",
            h92: "適合人群",
            h93: "★ 想要長期穩健投資、不想頻繁操作的用戶\n★ 需要自動化理財、省時省心的年輕投資者\n★ 投資 + 高息儲蓄 + 退休帳戶的人群\n★ 想要低成本進入金融市場的普通投資者",
        
            h28: "今日收益",
            h29: "總收益",
            h30: "提現",
            h31: "記錄",
            h32: "可用餘額",
            h33: "提現金額",
            h34: "請輸入提現金額",
            h35: "全部",
            h36: "提現",
            h37: "常見問題",
            h38: "有安全審計報告",
            h39: "合作夥伴",
            h40: "我們的業務夥伴",
            h41: "顯示銀行卡號",
            h42: "上一頁",
            h43: "下一頁",
            h44: "已經是第一頁",
            h45: "請輸入提現金額",
            h46: "餘額不足",
            h47: "已經是最後一頁",
            h48: "收入",
            h49: "支出",
            h50: "操作過於頻繁，請稍後再試。",
            h51: "審計報告",
            h52: "存幣生息",
            h521: "存款生息",
            h53: "訂單交易",
            h54: "註冊獎勵",
            h55: "邀請獎勵",
            h56: "提現",
            h57: "充值",
            h58: "存款",
            h59: "取款",
            h591: "存入成功",
            h592: "存入失敗",
            h593: "餘額不足",
            h60: "透過加密貨幣轉帳贈送USDT",
            h61: "感謝一直大力支持MetaMask銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉帳儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。（使用加密貨幣錢包提現同樣享有此優惠）",
            h61B: "感謝一直大力支持Coinbase銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉帳儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。",
            h61C: "感謝一直大力支持MetaMask銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉帳儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。",
            h61D: "感謝一直大力支持Betterment的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉帳儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。",
            h62: "您的取款金額為{amount}，手續費為{fee}%!",
            h63: "確認",
            h99: "待開放",
        },
        bankcard: {
            b1: "銀行帳戶",
            b2: "金融機構名稱",
            b3: "請輸入金融機構名稱",
            b4: "支行名稱",
            b5: "請輸入支行名稱",
            b6: "支行號碼",
            b7: "請輸入支行號碼",
            b8: "帳號（普通）",
            b9: "請輸入帳號",
            b10: "假名",
            b11: "請輸入用戶名",
            b12: "帳戶名義",
            b13: "請輸入帳戶名義人",
            b14: "綁定",
            b15: "虛擬幣地址",
            b16: "請輸入虛擬幣地址",
        },
        usdt: {
            u1: "我的訂單",
            u2: "存入",
            u3: "請選擇合約時間：",
            u4: "買入價格：",
            u5: "請輸入存入金額",
            u6: "增加買入",
            u7: "減少買入",
            u8: "操作成功",
            u9: "至少一點"
        },
        order: {
            o0: "我的訂單",
            o1: "訂單號",
            o2: "訂單類型",
            o3: "買入金額",
            o4: "賣出金額",
            o5: "支付金額",
            o6: "合約時間",
            o7: "訂單狀態",
            o8: "結算狀態",
            o9: "結算時間",
            o10: "下單時間",
            o11: "增加買入",
            o12: "減少買入",
            o13: "已賣出",
            o14: "盈利",
            o15: "虧損",
            o16: "已付費",
            o17: "盈虧平衡點"
        },
        recharge: {
            r1: "充值金額",
            r2: "充值金額數",
            r3: "充值類型",
            r4: "請選擇",
            r5: "充值地址",
            r6: "轉帳交易訂單號",
            r7: "已轉帳",
            r8: "審核中",
            r9: "輸入不正確",
            r10: "請選擇支付方式",
            r11: "最低充值金額為",
            r12: "充值上限金額為",
            r13: "請輸入金額",
            r14: "上傳支付截圖",
            r15: "請上傳支付截圖",
            r16: "提交成功",
            r17: "取消",
            r18: "確認",
        },
        rechargeDetails: {
            r1: "充值記錄",
            r2: "充值金額",
            r3: "審核中",
            r4: "充值成功",
            r5: "充值失敗"
        },
		cert: {
		    c1: "實名認證",
		    c2: "真實姓名",
		    c21: "請輸入真實姓名",
		    c3: "認證類型",
		    c31: "身份證",
		    c32: "護照",
		    c33: "駕駛證",
		    c10: "輸入認證類型",
		    c4: "證件正面",
		    c41: "請上傳證件正面",
		    c5: "證件反面",
		    c51: "請上傳證件反面",
		    c6: "提交",
		    c7: "提交成功，等待審核中...",
		    c8: "已通過認證",
		    c9: "實名認證未通過，請重新上傳",
		    c11: "審核中",
		    "传入字段不完整": "傳入欄位不完整",
		    "已认证过": "已認證過",
		    "审核中": "審核中"
		}
		 }